<template>
    <div
        class="form-group validation"
        :class="{ 'no-margin': noMargin, 'less-margin': lessMargin }"
        v-if="hasValidationData()"
        ref="wrapper"
    >
        <label v-show="showLabel"></label>
        <div class="form-component">
            <div class="flex items-center ml-2 mr-2 mt-2 text-base text-hh-orange-700">
                <img class="mr-2 w-4 mb-0.5" src="/assets/img/frontend-v3/icons/global/icon-x-red.svg" alt="❌">
                {{ validationMessage }}
            </div>
        </div>
    </div>
</template>

<script>

import {nextFrame} from "@/frontend-v3/Utils";

export default {
    name: "ValidationRow",

    props: [
        'validationData',
        'showLabel',
        'name',
        'noMargin',
        'lessMargin'
    ],

    data() {
        return {
            validationType: null,
            validationMessage: null,
            regex: null,
        }
    },

    created() {
        this.validationType = (this.validationData && this.validationData.type) ? this.validationData.type : 'error';
        this.validationMessage = this.validationData && this.validationData.message ? this.validationData.message : null;
    },

    mounted() {
        this.Bus.on('hide-validation-message', refName => {
            if (this._matchRef(refName)) {
                this.validationMessage = null;
            }
        });

        this.Bus.on('validation-message', async data => {
            if (this._matchRef(data.name)) {
                this.showMessage(data.message);

                // wait a single frame so that the v-if renders the wrapper
                await nextFrame();
                if (data.focus) {
                    this.$refs.wrapper?.parentNode?.scrollIntoView({ behavior: 'smooth' });
                }
            }
        });

        this.regex = new RegExp(
            // starting with $ because we want to match the full string, not a part of it
            '$' + this.name
                .replaceAll('[', '\\[')
                .replaceAll('*', '.+')
        );
    },

    watch: {
        validationData: function (data) {
            this.validationMessage = data.message;
        },
    },

    methods: {
        hasValidationData() {
            return this.validationMessage !== null;
        },

        showMessage(message) {
            this.validationMessage = message;
        },

        _matchRef(ref) {
            return ref === this.name || this.regex.test(ref);
        }
    }
}
</script>

<style scoped>

</style>
